import { Box, Typography } from "@mui/material";

/**
 * Outlined callout band: a headline (+ optional subline) on the left and an
 * action on the right, wrapping on narrow screens. Shared so the request-a-
 * calendar band and the review CTA read as one component. Spacing (margins) is
 * left to the call site via `sx`.
 *
 * @param {{ title: React.ReactNode, subtitle?: React.ReactNode,
 *   action: React.ReactNode, component?: React.ElementType, sx?: object }} props
 */
const CalloutBand = ({
  title,
  subtitle,
  action,
  component = "div",
  sx,
  ...props
}) => (
  <Box
    component={component}
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: { xs: 2, md: 3 },
      px: { xs: 3, md: 5 },
      py: { xs: 3, md: 3.5 },
      borderRadius: "16px",
      border: (theme) => `1.5px solid ${theme.palette.text.primary}`,
      ...sx,
    }}
    {...props}
  >
    <Box sx={{ flex: "0 1 auto", minWidth: 220 }}>
      <Typography
        component="h2"
        sx={{ fontSize: { xs: "19px", md: "22px" }, fontWeight: 800 }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography sx={{ fontSize: "15px", color: "text.secondary" }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    {action}
  </Box>
);

export default CalloutBand;
